<template>
    <div class="row">
        <div class="col">
            <card class="error" v-if="quoteRejected && !bidRoundCanceled">
                <card-content>
                    <span class="subtitle-1"><translate>Sie haben diese Anfrage abgelehnt, Sie können leider kein Angebot mehr abgeben</translate></span>
                </card-content>
            </card>
            <card class="warning" v-if="bidRoundEnded && !bidRoundCanceled">
                <card-content>
                    <span class="subtitle-1"><translate>Die Bietrunde ist beendet</translate></span>
                </card-content>
            </card>
            <card class="error" v-if="bidRoundCanceled">
                <card-content>
                    <span class="subtitle-1"><translate>Fertigungsanfrage abgebrochen</translate></span>
                </card-content>
            </card>
            <card>
                <card-content :class="{'blurred' : quoteRejected || bidRoundCanceled}">
                    <form @submit.prevent="submit">
                        <div class="row">
                            <div class="col col-6">
                                <h5>
                                    <translate render-html="true">Machen Sie uns ein Angebot. <strong>Hier und
                                        jetzt.</strong></translate>
                                </h5>
                                <p>
                                    <translate>Bieten Sie hier Ihren realistischen Bestpreis zu Ihrer bestmöglichen
                                        Lieferzeit. Den Zuschlag für das Projekt erhält der zuverlässigste Anbieter-
                                        gemessen an den drei Faktoren Qualität, Liefertreue und Preisattraktivität.
                                    </translate>
                                </p>
                                <p>
                                    <translate>Bitte geben Sie für jede Stückzahl Ihre Lieferzeit (in Kalendertagen ab
                                        Bestelleingang) und Ihren Gesamtpreis (für alle Bauteile in Euro, netto und
                                        inkl. Versandkosten) ein.
                                    </translate>
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <form-group v-if="askForQuote.bid_rounds[0].lotqty_1">
                                    <form-input id="qty_1" :label="this.$gettext('Bauteile')"
                                                :modelValue="askForQuote.bid_rounds[0].lotqty_1" disabled="true"
                                                :suffix="this.$gettext('Stück')"/>
                                    <form-input id="lot_delivery_1" v-model="form.lot_delivery_1" :label="this.$gettext('Lieferzeit')"
                                                :error="form.errors.lot_delivery_1"
                                                :info="!askForQuote.bid_rounds[0].lotqty_2 ? this.$gettext('in Kalendertagen') : ''"
                                                :placeholder="deliveryWish" :disabled="quoteRejected || bidRoundEnded"
                                                :suffix="this.$gettext('Kalendertage')" autocomplete="off"/>
                                    <form-input id="lot_offer_1" v-model="form.lot_offer_1" :label="this.$gettext('Preis')"
                                                :error="form.errors.lot_offer_1"
                                                :info="!askForQuote.bid_rounds[0].lotqty_2 ? this.$gettext('Preis für alle Bauteile inkl. Versand') : ''"
                                                :disabled="quoteRejected || bidRoundEnded" currency="true"
                                                :placeholder="this.$gettext('Preis in €')" autocomplete="off"/>
                                </form-group>
                                <form-group v-if="askForQuote.bid_rounds[0].lotqty_2">
                                    <form-input id="qty_2" :modelValue="askForQuote.bid_rounds[0].lotqty_2"
                                                disabled="true" :suffix="this.$gettext('Stück')"/>
                                    <form-input id="lot_delivery_2" v-model="form.lot_delivery_2"
                                                :error="form.errors.lot_delivery_2"
                                                :info="!askForQuote.bid_rounds[0].lotqty_3 ? this.$gettext('in Kalendertagen') : ''"
                                                :placeholder="deliveryWish" :disabled="quoteRejected || bidRoundEnded"
                                                :suffix="this.$gettext('Kalendertage')" autocomplete="off"/>
                                    <form-input id="lot_offer_2" v-model="form.lot_offer_2"
                                                :error="form.errors.lot_offer_2"
                                                :info="!askForQuote.bid_rounds[0].lotqty_3 ? this.$gettext('Preis für alle Bauteile inkl. Versand') : ''"
                                                :disabled="quoteRejected || bidRoundEnded" currency="true"
                                                :placeholder="this.$gettext('Preis in €')" autocomplete="off"/>
                                </form-group>
                                <form-group v-if="askForQuote.bid_rounds[0].lotqty_3">
                                    <form-input id="qty_3" :modelValue="askForQuote.bid_rounds[0].lotqty_3"
                                                disabled="true" :suffix="this.$gettext('Stück')"/>
                                    <form-input id="lot_delivery_3" v-model="form.lot_delivery_3"
                                                :error="form.errors.lot_delivery_3"
                                                :info="!askForQuote.bid_rounds[0].lotqty_4 ? this.$gettext('in Kalendertagen') : ''"
                                                :placeholder="deliveryWish" :disabled="quoteRejected || bidRoundEnded"
                                                :suffix="this.$gettext('Kalendertage')" autocomplete="off"/>
                                    <form-input id="lot_offer_3" v-model="form.lot_offer_3"
                                                :error="form.errors.lot_offer_3"
                                                :info="!askForQuote.bid_rounds[0].lotqty_4 ? this.$gettext('Preis für alle Bauteile inkl. Versand') : ''"
                                                :disabled="quoteRejected || bidRoundEnded" currency="true"
                                                :placeholder="this.$gettext('Preis in €')" autocomplete="off"/>
                                </form-group>
                                <form-group v-if="askForQuote.bid_rounds[0].lotqty_4">
                                    <form-input id="qty_4" :modelValue="askForQuote.bid_rounds[0].lotqty_4"
                                                disabled="true" :suffix="this.$gettext('Stück')"/>
                                    <form-input id="lot_delivery_4" v-model="form.lot_delivery_4"
                                                :error="form.errors.lot_delivery_4" :info="this.$gettext('in Kalendertagen')"
                                                :placeholder="deliveryWish" :disabled="quoteRejected || bidRoundEnded"
                                                :suffix="this.$gettext('Kalendertage')" autocomplete="off"/>
                                    <form-input id="lot_offer_4" v-model="form.lot_offer_4"
                                                :error="form.errors.lot_offer_4"
                                                :info="this.$gettext('Preis für alle Bauteile inkl. Versand')"
                                                :disabled="quoteRejected || bidRoundEnded" currency="true"
                                                :placeholder="this.$gettext('Preis in €')" autocomplete="off"/>
                                </form-group>

                                <form-actions>
                                    <form-button type="button" icon="delete-disabled" color="error"
                                                 :disabled="quoteRejected || bidRoundEnded"
                                                 @click="rejectDialog = !rejectDialog"
                                                 v-if="!askForQuote.bid_rounds[0].bid_round_members[0].offer_given">
                                        <translate>Anfrage ablehnen</translate>
                                    </form-button>
                                    <form-button type="button" icon="delete-disabled"
                                                 :disabled="quoteRejected || bidRoundEnded"
                                                 v-if="askForQuote.bid_rounds[0].bid_round_members[0].offer_given"
                                                 @click="dropOffer">
                                        <translate>Angebot zurückziehen</translate>
                                    </form-button>
                                    <form-button type="submit" color="secondary" icon="button-arrow-right-circle"
                                                 :disabled="quoteRejected || bidRoundEnded || form.processing" :class="{'btn--processing': form.processing}">
                                        <translate v-if="!askForQuote.bid_rounds[0].bid_round_members[0].offer_given">
                                            verbindliches Angebot abgeben
                                        </translate>
                                        <translate v-if="askForQuote.bid_rounds[0].bid_round_members[0].offer_given">
                                            verbindliches Angebot aktualisieren
                                        </translate>
                                    </form-button>
                                </form-actions>
                            </div>
                        </div>
                    </form>
                </card-content>
                <component-reject :bidRoundMember="askForQuote.bid_rounds[0].bid_round_members[0]" v-if="rejectDialog"
                                  @closeDialog="rejectDialog = false"/>
            </card>
        </div>
    </div>
</template>

<script>
import CardContent from '@partfactory/Shared/Card/CardContent';
import Card from '@partfactory/Shared/Card/Card';
import FormGroup from '@partfactory/Shared/Form/FormGroup';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormActions from '@partfactory/Shared/Form/FormActions';
import {useForm} from '@inertiajs/vue3';
import ComponentReject from '@partfactory/Pages/Producer/Component/ComponentReject';

export default {
    name: 'ComponentOffer',
    components: {
        ComponentReject, FormActions, FormButton, FormInput, FormGroup, Card, CardContent
    },
    props: {
        askForQuote: Object,
    },
    data() {
        let rejectDialog = false;
        const form = useForm({
            lot_offer_1: this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_offer_1,
            lot_offer_2: this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_offer_2,
            lot_offer_3: this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_offer_3,
            lot_offer_4: this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_offer_4,
            lot_delivery_1: this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_delivery_1 ? this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_delivery_1 : this.askForQuote.bid_rounds[0].delivery_days_for_producer,
            lot_delivery_2: this.askForQuote.bid_rounds[0].lotqty_2 ? this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_delivery_2 ? this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_delivery_2 : this.askForQuote.bid_rounds[0].delivery_days_for_producer : null,
            lot_delivery_3: this.askForQuote.bid_rounds[0].lotqty_3 ? this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_delivery_3 ? this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_delivery_3 : this.askForQuote.bid_rounds[0].delivery_days_for_producer : null,
            lot_delivery_4: this.askForQuote.bid_rounds[0].lotqty_4 ? this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_delivery_4 ? this.askForQuote.bid_rounds[0].bid_round_members[0]?.lot_delivery_4 : this.askForQuote.bid_rounds[0].delivery_days_for_producer : null,
        });

        return {rejectDialog, form};
    },
    computed: {
        offerValidUntil() {
            let offerValidiy = this.$moment(this.askForQuote.bid_rounds[0].ending_at).add(this.askForQuote.bid_rounds[0].p_custom_offer_validity, 'days');
            if (!offerValidiy.isBusinessDay() || offerValidiy.isHoliday()) {
                offerValidiy = offerValidiy.nextBusinessDay();
            }
            return offerValidiy;
        },
        deliveryWish() {
            // const deliveryDate = this.$moment(this.askForQuote.bid_rounds[0].ask_for_quote.delivery_date);
            // return this.$moment(this.askForQuote.bid_rounds[0].ending_at).businessDiff(deliveryDate) + ' Kalendertage';
            return this.askForQuote.bid_rounds[0].delivery_days_for_producer + ' ' + this.$gettext('Kalendertage');
        },
        quoteRejected() {
            return !!this.askForQuote.bid_rounds[0].bid_round_members[0]?.rejected;
        },
        bidRoundEnded() {
            return !!(this.$moment().diff(this.askForQuote.bid_rounds[0].ending_at) > 0);
        },
        bidRoundCanceled() {
            return this.askForQuote.bid_rounds[0].canceled;
        },
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                    offer_valid_until: this.offerValidUntil,
                }))
                .patch(this.$$route('quote.update', {'bidRoundMember': this.askForQuote.bid_rounds[0].bid_round_members[0].id}));
        },
        dropOffer() {
            this.$inertia.post(this.$$route('quote.drop', {'bidRoundMember': this.askForQuote.bid_rounds[0].bid_round_members[0].id}));

            this.form.lot_offer_1 = null;
            this.form.lot_offer_2 = null;
            this.form.lot_offer_3 = null;
            this.form.lot_offer_4 = null;
            this.form.lot_delivery_1 = this.askForQuote.bid_rounds[0].delivery_days_for_producer;
            this.form.lot_delivery_2 = this.askForQuote.bid_rounds[0].delivery_days_for_producer;
            this.form.lot_delivery_3 = this.askForQuote.bid_rounds[0].delivery_days_for_producer;
            this.form.lot_delivery_4 = this.askForQuote.bid_rounds[0].delivery_days_for_producer;
        }
    }
};
</script>

<style scoped>

</style>
